import { useState } from "react";
import { createNoteTemplate as createNoteTemplateService } from "@/services/notesTemplates";
import type { CreateNoteTemplateRequestBody } from "@/common/types/notesTemplates";

export const useCreateNoteTemplate = (): {
  createNoteTemplate: (body: CreateNoteTemplateRequestBody) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const createNoteTemplate = async (
    body: CreateNoteTemplateRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);
    try {
      await createNoteTemplateService(body);
      setResult(true);
    } catch {
      setResult(false);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { createNoteTemplate, result, loading, error };
};
